<template>
    <span v-if="tomorrow">
        <template v-if="todayIsTransdate == 1">
            <template v-if="nowTimeSection == 0">
                <span>最终结果将于</span><span>{{nowTime.months}}</span><span>月</span><span>{{nowTime.days}}</span><span>日收盘后公布</span>
            </template>
            <template v-else-if="nowTimeSection == 1">
                <span>{{nowTime.months}}</span><span>月</span><span>{{nowTime.days}}</span><span>日竞猜已经结束</span><br/>
                <span>{{nowTime.months}}</span><span>月</span><span>{{nowTime.days}}</span><span>日{{baseConf.resultTime}}后可进行</span><span>{{tomorrow.months}}</span><span>月</span><span>{{tomorrow.days}}</span><span>日的大盘</span>
            </template>            
            <template v-else-if="nowTimeSection == 2">
                <span>最终结果将于</span><span>{{tomorrow.months}}</span><span>月</span><span>{{tomorrow.days}}</span><span>日收盘后公布</span>
            </template>
        </template>
        <template v-else>
            <span>最终结果将于</span><span>{{tomorrow.months}}</span><span>月</span><span>{{tomorrow.days}}</span><span>日大盘涨跌竞猜中</span>
        </template>        
    </span>
</template>
<script>
    import {mapGetters, mapState} from 'vuex'
    export default {
        data() {
            return {
                
            }
        },
        computed: {
            ...mapGetters('home', ['nowTime', 'tomorrow', 'todayIsTransdate', 'nowTimeSection']),
            ...mapState('home', ['baseConf'])
        },
        methods: {
            
        },
    }
</script>